module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter111",
    attrs: {
      "id": "int"
    }
  }, [_c('a', {
    attrs: {
      "id": "pageiii"
    }
  }), _vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "dropcaps3lines"
  }, [_vm._v("Y")]), _vm._v("ou knew there was a secret language of knitters, didn’t you? You followed the “open” sign of a local yarn store like a foundering sailor following the beacon of a lighthouse, only to discover that once you found what should be your spiritual home, you didn’t understand half of the words or any of the jokes. People were laughing about having tons of UFOs—had you stumbled into a sci-fi convention by mistake? They were talking about SABLE (fur?) and SEX—well, you knew what that was but why were groups of knitting women and men talking about doing it as a group right out loud in front of everybody? What kind of cult is this, after all? Perhaps you ran screaming into the night—but something (perhaps the cashmere) keeps drawing you back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I present to you your field guide to the secret language of knitters. Because unlike many other groups that have been studied by outsiders (gorillas come to mind), we actually want you to join "), _c('a', {
    attrs: {
      "id": "pageiv"
    }
  }), _vm._v("us. We want you to learn our language and become one of us. We want to welcome you with open arms, to convert you to our way of life. OK, maybe it is a little cult-like after all, but I mean that in the best possible sense. You can go anywhere in the country, find a yarn shop, and be instantly at home. And now you, too, can laugh at the jokes.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b7fca0d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780740793271_epub_int_r1.vue
// module id = 69
// module chunks = 0